import React from 'react';
import Card from '@mui/material/Card';
import ButtonBase from '@mui/material/ButtonBase';
import CardTabSlide from './CardTabSlide';
import useLocalStorage from '../../Util/custom-hooks/UseLocalStorage';

function CreateRoomCard({ children, dark, tabText, onClick, iconLeft, iconRight, menu }) {
    const [tileSize] = useLocalStorage('tile-size', 135); // TODO: delete eventually - used in Settings.js
    return (
        <Card
            sx={{
                cursor: 'pointer',
                height: '100%',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                '& dd': {
                    height: '2em',
                    paddingTop: 0
                }
            }}
            style={{
                maxWidth: `${tileSize}px`,
                minWidth: `${tileSize}px`,
                maxHeight: `${tileSize}px`,
                minHeight: `${tileSize}px`
            }}>
            <span style={{ position: 'absolute', left: 0, top: 0 }}>{iconLeft}</span>
            <span style={{ position: 'absolute', right: 0, top: 0 }}>{iconRight}</span>
            <ButtonBase
                onClick={onClick}
                style={{
                    width: '100%',
                    height: '100%',
                    outline: 0
                }}>
                {children}
            </ButtonBase>
            <CardTabSlide dark={dark} text={tabText} menu={menu} />
        </Card>
    );
}

export default CreateRoomCard;
